module.exports = __webpack_public_path__ + "img/reading-hours.52ca2d57.svg";